// extracted by mini-css-extract-plugin
export default {"EventDetailsExpand":"EventDetailsForm_EventDetailsExpand__ZwNNw","expand":"EventDetailsForm_expand__AXWeZ"};